module.exports = __webpack_public_path__ + "static/media/vehicle-pin-lightAlt.e5a272c2.svg";